<style lang="less">
    @import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list">
        <div class="table-list" style="margin-top:25px;height: auto;min-height: 726px;">
            <div class="table-list-title">
                <span style="margin-left:25px">预登记列表</span>
                <div class="choose-group">
                    <span class="choose-group-span">登记时间</span>
                    <Date-picker v-model="dateValue"
                                 format="yyyy-MM-dd"
                                 type="daterange"
                                 placement="bottom-end"
                                 @on-change="timeChange"
                                 placeholder="选择日期" style="width: 200px"></Date-picker>

                    <i-input v-model="workFullName"
                             ref="workFullNameInput"
                             :search="true"
                             @on-search="searchReset"
                             placeholder="请输入作品名称"
                             style="width: 205px"
                             class="select-input-style"></i-input>
                    <button @click="searchReset" class="btn-84" style="margin:0 30px 0 0px">查询</button>
                    <button @click="toRegDetail" class="btn-84" style="margin:0 30px 0 0px">新增预登记</button>
                </div>
            </div>
            <Row class="table-style-size">
                <i-col span="5">订单编号</i-col>
                <i-col span="4">作品名称</i-col>
                <!--                <i-col span="2">登记类型</i-col>-->
                <i-col span="2">已提交登记</i-col>
                <i-col span="2">证书</i-col>
                <i-col span="2">状态</i-col>
                <i-col span="3">登记时间</i-col>
                <i-col span="5">操作</i-col>
            </Row>

            <errorTips :state="0" v-if="loadFlag && records.length == 0"></errorTips>


            <div v-else>
                <Row v-for="(item,index) in records" class="table-style-size table-style-body">
                    <i-col span="5">
                        <Tooltip :content="item.orderSeqNo" placement="top">
                            <span class="text-overflow-2" style="padding:0 5px">{{ item.orderSeqNo }}</span>
                        </Tooltip>
                    </i-col>
                    <i-col span="4">
                        <Tooltip :content="item.workFullName" placement="top">
                            <span class="text-overflow-2" style="padding:0 5px">{{ item.workFullName }}</span>
                        </Tooltip>
                    </i-col>
                    <i-col span="2" v-if="item.applyStatus == '1'">是</i-col>
                    <i-col span="2" v-else>否</i-col>
                    <i-col span="2">
                      <router-link v-if="item.preCertUrl && item.preCertUrl!='' " :to="item.preCertUrl" style="margin-right: 5px;">
                        <img src="@/assets/yy.png" style="width: 25px;height: 25px;"/>
                      </router-link>
                      <img v-else src="@/assets/yw.png" alt="" style="margin-right: 5px; width: 25px;height: 25px;">

                      <router-link v-if="item.certUrl && item.certUrl!='' " :to="'/copyrightCert?url=' + item.cerImgPrivateUrl">
                          <img src="@/assets/dci.png" style="width: 25px;height: 25px;"/>
                      </router-link>
                      <img v-else src="@/assets/dci_close.png" style="width: 25px;height: 25px;" alt="">
                    </i-col>
                    <i-col span="2" v-if="item.applyStatus == '0' && item.orderStatus == 'wait_identify' && item.preCertUrl == null">预登记中</i-col>
                    <i-col span="2" v-if="item.applyStatus == '0' && item.orderStatus == 'wait_identify' && item.preCertUrl != null">预登记完成</i-col>
                    <i-col span="2" v-if="item.applyStatus == '1' && item.orderStatus == 'identifying' && item.certUrl == null">版权登记中</i-col>
                    <i-col span="2" v-if="item.applyStatus == '1' && item.orderStatus == 'wait_identify'">版权登记中</i-col>
                    <i-col span="2" v-if="item.applyStatus == '1' && item.orderStatus == 'identify' && item.certUrl != null">版权登记完成</i-col>
                    <i-col span="2" v-if="item.orderStatus == 'reject_enable'">驳回可编辑</i-col>
                    <i-col span="2" v-if="item.orderStatus == 'reject_disable'">驳回不可编辑</i-col>

                    <i-col span="3">{{ item.createDate }}</i-col>
                    <i-col span="5">
                        <router-link :to="'/preDetails?id=' + item.orderSeqNo" class="btn-84"
                                     style="display: inline-block;margin:0 15px">详情
                        </router-link>
                        <router-link  v-if="item.orderStatusCn == '驳回可编辑' " :to="'/preLogin?id=' + item.orderSeqNo" class="btn-84"
                                      style="display: inline-block;margin:0 15px">修改
                        </router-link>
<!--                        <a v-if="item.certUrl && item.certUrl!='' " :href="item.certUrl" target="_blank" class="btn-84"
                           style="display: inline-block;">下载证书</a>-->
                    </i-col>
                </Row>
                <div class="commont-page" style="position: absolute;bottom: 10px;left: 50%;transform: translate(-50%, -50%);">
                    <Page @on-change="changepage"
                          :current="pageNumber"
                          :page-size="pageSize"
                          :total="total"
                          size="small"
                          show-total
                          show-elevator
                          class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import {_getByPage} from '../../../api/preRegister'
    import errorTips from '@/views/main-components/error-tips';
    import Cookies from "js-cookie";

    export default {
        name: 'myPre',
        metaInfo: {
            title: '我的预登记|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            }, {
                name: 'Description',
                content: ''
            }]
        },
        components: {
            errorTips
        },
        data() {
            return {
                userInfo: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : '',
                total: 0, //总数量
                pageNumber: 1, //当前页面
                pages: 1, //总页数
                pageSize: 8, //数据尺寸
                dateValue: [], //时间
                records: [], //登记数据
                workFullName: '', //登记名称
                loadFlag: false //加载flag
            }
        },
        created() {
        },
        mounted() {
            this.getByPage();

        },
        methods: {
            toRegDetail(){
				let _this = this ;
				let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
				if(userInfo==''){
					toast('请登录后再进行登记',function () {
						// _this.$router.push({path:"/"})
					})
					return false;
				}else if(userInfo.vipFlag == "0"){
					toast("请开通VIP服务后进行操作");
				}else{
          let query = {
            code:2004
          };
          this.$router.push({ path:'/preLogin', query: query })
				}
        	},
            /*********获取列表数据********/
            getByPage() {
                this.$refs['workFullNameInput'].blur();

                let data = {
                    pageNumber: this.pageNumber,
                    pageSize: this.pageSize,
                    sort: '',
                    order: 'desc',
                    startDate: (this.dateValue[0] ? this.dateValue[0] : ''),
                    endDate: (this.dateValue[1] ? this.dateValue[1] : ''),
                    workFullName: this.workFullName,
                    // registerId: this.userInfo.id,
                    orderStatus: ''
                };

                _getByPage(data).then(res => {
                    //debugger ;
                    if (res.code == 200) {
                        let result = res.result;
                        this.total = result.total - 0;
                        this.pages = result.pages;
                        this.records = result.records;
                        this.loadFlag = true;
                    } else {
                        toast(res.message);
                    }
                }, (err) => {
                    toast('网络断开连接，请重试')
                })


            },


            /*********时间改变事件********/
            timeChange(value) {
                this.dateValue = value;
                this.searchReset()
            },

            /*********页数改变事件********/
            changepage(index) {
                this.pageNumber = index;
                this.getByPage()
            },

            /*********搜索重置事件********/
            searchReset() {
                this.pageNumber = 1;
                this.getByPage();
            }

        }
    }
</script>